var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav',{attrs:{"title":"Bạn bè mới"}}),_c('List',{attrs:{"url":"/rooms/apply/friend"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('UserItem',{staticClass:"useritem_wrap",attrs:{"img":item.userimg,"text":item.username},on:{"click":function($event){return _vm.handleClick(item)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }